export enum Permission {
  StoreInterventionsView = 'store_interventions.view',
  StoreInterventionsModify = 'store_interventions.modify',
}
